import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { LayoutGrid } from "lucide-react";
 * // Use <LayoutGrid /> instead
 */
export const ViewWideTilesIcon = createSVGWrapper(
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V5ZM5 9V6H19V9H5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V14ZM5 18V15H19V18H5Z"
      clipRule="evenodd"
    />
  </>
);
